// ¿Hay ya una sesión firmada vigente para este empleado en este navegador?
// Se usa antes de re-emitir (issueWithoutPin): re-emitir rota el token y
// corta las peticiones en vuelo.
export function hasValidEmployeeSessionFor(employeeId, storage = window.localStorage, now = new Date()) {
  try {
    const token = storage.getItem("EmployeeSessionToken");
    const expiresAt = storage.getItem("EmployeeSessionExpiresAt");
    const info = JSON.parse(storage.getItem("EmployeeSessionInfo") || "null");
    if (!token) return false;
    if (expiresAt && new Date(expiresAt) <= now) return false;
    return Number(info?.employeeId) === Number(employeeId);
  } catch {
    return false;
  }
}
